export const isAppAdmin = (roleCode) =>
    String(roleCode || "").toUpperCase() === "APP_ADMIN";

export default isAppAdmin;
